import React, { memo } from 'react';
import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';

import styles from './LogoutLoader.module.css';
import { LogoutLoaderProps } from './LogoutLoader.types';

const LogoutLoader: React.FC<LogoutLoaderProps> = memo(({ isVisible }) => {
  return createPortal(
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className={styles.overlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div
            className={styles.content}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ delay: 0.15, duration: 0.35, ease: 'easeOut' }}
          >
            <div className={styles.logoContainer}>
              <div className={styles.glowPulse} />
              <div className={styles.ringOuter} />
              <div className={styles.ringInner} />
              <motion.div
                className={styles.logoIcon}
                animate={{ scale: [1, 1.08, 1] }}
                transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
              >
                S
              </motion.div>
            </div>

            <h2 className={styles.message}>See you soon!</h2>

            <p className={styles.subMessage}>
              Signing out
              <span className={styles.dots}>
                <span>.</span>
                <span>.</span>
                <span>.</span>
              </span>
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
});

LogoutLoader.displayName = 'LogoutLoader';

export default LogoutLoader;
